import { create } from 'zustand';

/**
 * API Endpoint Configuration Interface
 */
interface ApiEndpointConfig {
  apiGateway: string;
  iotApiGateway: string;
  gpsWebSocketUrl: string;
  eventWebSocketUrl: string;
}

/**
 * API Endpoint Store State Interface
 */
interface ApiEndpointState {
  config: ApiEndpointConfig | null;
  isInitialized: boolean;
  setConfig: (config: ApiEndpointConfig) => void;
  clearConfig: () => void;
}

/**
 * API Endpoint Store
 * Manages all API endpoints and tokens centrally
 */
export const useApiEndpointStore = create<ApiEndpointState>((set) => ({
  config: null,
  isInitialized: false,
  
  setConfig: (config: ApiEndpointConfig) => {
    console.log('🔧 [ApiEndpointStore] Setting API endpoint configuration:', {
      apiGateway: config.apiGateway,
      iotApiGateway: config.iotApiGateway
    });
    
    set({
      config,
      isInitialized: true
    });
  },
  
  clearConfig: () => {
    console.log('🧹 [ApiEndpointStore] Clearing API endpoint configuration');
    
    set({
      config: null,
      isInitialized: false
    });
  }
}));